import React, { useState } from "react"
import Select from "react-select"
import { getCurrentLang, setCurrentLang } from "../../i18n"
import { useTranslation } from "react-i18next"
import { withSecondary } from "./elements"
import styled from "styled-components"
import media from "../../utils/media"

const SelectContainer = styled.div`
  min-width: 120px;
  width: fit-content;
  ${media.tablet`min-width: 50px`}
`

const TranslateComponentItem = withSecondary(({ secondary, ...props }) => {
  const { t } = useTranslation()

  const options = [
    { value: "es", label: `${t("spanish")}` },
    { value: "en", label: `${t("english")}` }
  ]

  const optionsMobile = [
    { value: "es", label: "ES" },
    { value: "en", label: "EN" }
  ]

  const [selectedLang, setSelectedLang] = useState(getCurrentLang())
  const colourStyles = {
    control: styles => ({
      ...styles,
      borderStyle: "none",
      borderColor: secondary ? "transparent" : "white",
      boxShadow: "transparent",
      backgroundColor: "transparent"
    }),
    valueContainer: styles => ({ ...styles, padding: "0"}),
    dropdownIndicator: styles => ({ ...styles, color: secondary ? "#fff" : "#CCCCCC", ":hover": {
      ...styles[":hover"],
      color: secondary ? "#fff" : "#CCCCCC"
    }}),
    indicatorSeparator: styles => ({ ...styles, background: "transparent"}),
    singleValue: (styles, { data }) => ({
      ...styles,
      textOverflow: "clip",
      marginLeft: "0",
      marginRight: "0",
      color: secondary ? "#fff" : "#575757",
      fontSize: "20px",
      fontWeight: "500",
      maxWidth: "100%"
    }),
    option: (styles, { isDisabled, isFocused, isSelected }) => {
      const color = "#FF7F00"
      const lightColor = "white"
      return {
        ...styles,
        backgroundColor: isDisabled
          ? null
          : isSelected
          ? color
          : isFocused
          ? lightColor
          : null,
        cursor: isDisabled ? "not-allowed" : "default",

        ":active": {
          ...styles[":active"],
          color,
          backgroundColor: !isDisabled && (isSelected ? color : lightColor)
        }
      }
    }
  }

  function handleChange(selectedOption) {
    setCurrentLang(selectedOption.value)
    setSelectedLang(selectedOption.value)
  }

  function getCurrentLabel() {
    if (props.mobile) {
      return selectedLang === "en" ? "EN" : "ES"
    } else {
      const mLabelKey = selectedLang === "en" ? "english" : "spanish"
      return t(mLabelKey)
    }
  }

  return (
    <SelectContainer>
    <Select
      value={{ value: selectedLang, label: getCurrentLabel() }}
      onChange={handleChange}
      options={props.mobile ? optionsMobile : options}
      styles={colourStyles}
    />
    </SelectContainer>
  )
})

export default TranslateComponentItem
